import { ITableRowData } from "../../../manager/components/data-table/data-table";
import { IObject } from "../../../shared/utils/utils";

export function transformToBackendRelatedEntity(data: any) { // eslint-disable-line 
  return {
    id: data.id,
    data: data.data.map((item: ITableRowData) => ({
      id: item.id,
      related_entity_id: item.related_entity_id,
      related_entity_type_id: item.related_entity_type_id
    }))
  };
}

export function transformFromBackendRelatedEntity(backendType: any) { // eslint-disable-line
  return backendType.map((item: IObject) => ({
    ...item,
    id: item.sygno_id
  }));
}
